import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import axios from "axios";
import {
  Table,
  Button,
  Col,
  Row,
  Label,
  Input,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";

function ReporteCargos() {
  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 90);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");
  const { user } = useContext(AuthContext);
  const URL_CARGOS = process.env.REACT_APP_URL_CARGOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  const [cargos, setCargos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [clientesEdit, setClientesEdit] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedTipo, setSelectedTipo] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");
  const [totalTotalImporte, setTotalTotalImporte] = useState(0);
  const [totalTotalAbonos, setTotalTotalAbonos] = useState(0);
  const [totalTotalSaldo, setTotalTotalSaldo] = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;



  useMemo(() => {
    axios
      .get(`${URL_CARGOS}/Reportefechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCargos = response.data;
        let dataFinal = Object.values(allCargos);
        setComments(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  function PDFTabla() {
    const data = comments.map((c) => {
      if (
        (selectedTipo == 0 || selectedTipo == c.tipoAbono) &&
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha)
      ) {
        return [
          c.fecha,
          c.propiedad,
          "$" + new Intl.NumberFormat("en-US").format(c.importe),
          "$" + new Intl.NumberFormat("en-US").format(c.abonos),
          "$" + new Intl.NumberFormat("en-US").format(c.saldo),
          c.fechaAbono,
          c.tipoAbono,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);
    doc.addImage(img, "png", 230, 15, 45, 15);
    doc.text("Reporte de Cargos", 15, 25);
    doc.autoTable({
      head: [
        [
          "Fecha",
          "Propiedad",
          "Importe",
          "Abonos",
          "Saldo",
          "Fecha Abono",
          "Tipo Abono",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "TOTAL",
          "$" + new Intl.NumberFormat("en-US").format(totalTotalImporte),
          "$" + new Intl.NumberFormat("en-US").format(totalTotalAbonos),
          "$" + new Intl.NumberFormat("en-US").format(totalTotalSaldo),
          "",
          "",
        ],
      ],
      showFoot: "lastPage",
    });
    doc.save("ReporteCargos.pdf");
  }

  function excel() {
    const dataExcel = comments.map((c) => {
      if (
        (selectedTipo == 0 || selectedTipo == c.tipoAbono) &&
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha)
      ) {
        return {
          Fecha: c.fecha,
          Propiedad: c.propiedad,
          Importe: c.importe,
          Abonos: c.abonos,
          Saldo: c.saldo,
          FechaAbono: c.fechaAbono,
          TipoAbono: c.tipoAbono,
        };
      }
    });

    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ReporteCargos";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ReporteCargos",
        sheetFilter: [
          "Fecha",
          "Propiedad",
          "Importe",
          "Abonos",
          "Saldo",
          "FechaAbono",
          "TipoAbono",
        ],
        sheetHeader: [
          "Fecha",
          "Propiedad",
          "Importe",
          "Abonos",
          "Saldo",
          "FechaAbono",
          "TipoAbono",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((c) => {
      if (
        (selectedTipo == 0 || selectedTipo == c.tipoAbono) &&
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha)
      ) {
        return [
          c.fecha,
          c.propiedad,
          "$" + new Intl.NumberFormat("en-US").format(c.importe),
          "$" + new Intl.NumberFormat("en-US").format(c.abonos),
          "$" + new Intl.NumberFormat("en-US").format(c.saldo),
          c.fechaAbono,
          c.tipoAbono,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);
    doc.addImage(img, "png", 230, 15, 45, 15);
    doc.text("Reporte de Cargos", 15, 25);
    doc.autoTable({
      head: [
        [
          "Fecha",
          "Propiedad",
          "Importe",
          "Abonos",
          "Saldo",
          "Fecha Abono",
          "Tipo Abono",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "TOTAL",
          "$" + new Intl.NumberFormat("en-US").format(totalTotalImporte),
          "$" + new Intl.NumberFormat("en-US").format(totalTotalAbonos),
          "$" + new Intl.NumberFormat("en-US").format(totalTotalSaldo),
          "",
          "",
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Reporte Cargos",
          email: mailTo,
          fileName: "Reporte-Cargos.pdf",
          att: base64File,
          text: `<!DOCTYPE html>
         <html>
           <head>
             <style>                                
               .img-container {
                               display: block;
                               margin-left: auto;
                               margin-right: auto;
                               height: 90px;
                               width: auto;
                             }
             </style>
           </head>
           <body>
             <img class="img-container" alt="Logo" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" />              
             <h1>${process.env.REACT_APP_NOMBRE_INSTITUCION}</h1>
             <h3>Hola,</h3>
             <h3>Adjunto encontraras el reporte de cargos.</h3>
             <h4>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</h4>
             Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> 
           </body>
         </html>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }


  const headers = [
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "Propiedad", field: "propiedad", sortable: true },
    { name: "Importe", field: "importe", sortable: true },
    { name: "Abonos", field: "abonos", sortable: true },
    { name: "Saldo", field: "saldo", sortable: true },
    { name: "Fecha Abono", field: "fechaAbono", sortable: true },
    { name: "Tipo", field: "tipoAbono", sortable: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter((comment) =>
        comment.propiedad.toLowerCase().includes(search.toLowerCase()) ||
        comment.tipoAbono.toLowerCase().includes(search.toLowerCase()) ||
        comment.importe.toString().includes(search) ||
        comment.saldo.toString().includes(search) ||
        comment.abonos.toString().includes(search)
      );
    }

    if (selectedTipo) {
      computedComments = computedComments.filter((e) =>
        e.tipoAbono.includes(selectedTipo)
      );
    }

    let car = computedComments.map((c) => parseFloat(c.importe));
    let TCar = car.reduce((t, cargos, index) => t + cargos, 0);
    setTotalTotalImporte(TCar);

    let abo = computedComments.map((c) => parseFloat(c.abonos));
    let TAbo = abo.reduce((t, abonos, index) => t + abonos, 0);
    setTotalTotalAbonos(TAbo);

    let sal = computedComments.map((c) => parseFloat(c.saldo));
    let Tsal = sal.reduce((t, abonos, index) => t + abonos, 0);
    setTotalTotalSaldo(Tsal);


    setTotalItems(computedComments.length);

 //Sorting comments
 if (
  sorting.field &&
  sorting.field != "importe" &&
  sorting.field != "abonos" &&
  sorting.field != "saldo"
) {
  const reversed = sorting.order === "asc" ? 1 : -1;
  computedComments = computedComments.sort(
    (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
  );
}

if (
  sorting.field &&
  sorting.order === "asc" &&
  (sorting.field == "importe" || sorting.field == "abonos" || sorting.field == "saldo")
) {
  computedComments = computedComments.sort((a, b) =>
    parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
  );
}

if (
  sorting.field &&
  sorting.order === "desc" &&
  (sorting.field == "importe" || sorting.field == "abonos" || sorting.field == "saldo")
) {
  computedComments = computedComments.sort((a, b) =>
    parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
  );
}

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting, selectedTipo]);

  return (
    <>
      <Header />
      <br />
      <br />
      {user.usuarios_permisos ? (
        <div className="card container col-sm-11">
          <Row>
            <Col sm={8}>
              <Button
                        size="sm"
                        href="/MenuCargos"
                        className="btn btn-danger"
                        id="botonReporte"
                      >
                        Regresar
                      </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="info"
                  onClick={toggleMail}
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Reporte Cargos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          <h3 align="center">Reporte Cargos</h3>

          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
            <Label className="mr-sm-2">Tipo</Label>
            <Input
                  bsSize="sm"
                  type="select"
                  value={selectedTipo}
                  required
                  onChange={(e) => {
                    setSelectedTipo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Kasher">Kasher</option>
                  <option value="Taref">Taref</option>
                  
                </Input>
            </Col>
            {/* <Col md={1}>
                    <Button     
                    size="sm"   
                        className="btn ir" 
                        color="info"
                        onClick={jalaFechas}
                        >
                          Ir 
                        </Button>
                    </Col> */}
          </Row>

          <div className="row">
            <div className="col-md-6">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-6 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            {/* <tr>
              <td></td>

              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCliente}
                  required
                  onChange={(e) => {
                    setSelectedCliente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
            </tr> */}
            <tbody>
              {commentsData.map((c) => {
                return (
                  <tr>
                    <td>{c.fecha}</td>
                    <td>{c.propiedad}</td>
                    <td>
                      {"$" + new Intl.NumberFormat("en-US").format(c.importe)}
                    </td>
                    <td>
                      {"$" + new Intl.NumberFormat("en-US").format(c.abonos)}
                    </td>
                    <td>
                      {"$" + new Intl.NumberFormat("en-US").format(c.saldo)}
                    </td>
                    <td>{c.fechaAbono}</td>
                    <td>{c.tipoAbono}</td>
                  </tr>
                );
              })}
              <tr>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL
                </td>
                <td className="negrita">
                  {"$" + new Intl.NumberFormat("en-US").format(totalTotalImporte)}
                </td>
                <td className="negrita">
                  {"$" + new Intl.NumberFormat("en-US").format(totalTotalAbonos)}
                </td>
                <td className="negrita">
                  {"$" + new Intl.NumberFormat("en-US").format(totalTotalSaldo)}
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </Table>

          <Pagination
            total={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      ) : undefined}
      {loader}
    </>
  );
}

export default ReporteCargos;
